module.exports = __webpack_public_path__ + "static/media/drinking.fd86037b.png";